import { FC } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

import { Paginator } from "../../types";
import { useForm } from "../../app/useForm";
import { MEDIUM_ICON_SIZE_STYLES } from "../../../ui/styles";

type RowPaginatorProps = { paginator: Paginator };

const PAGINATOR_ICON_STYLES = `text-stone-500 cursor-pointer ${MEDIUM_ICON_SIZE_STYLES}`;

export const RowPaginator: FC<RowPaginatorProps> = ({ paginator }) => {
  const { handleFormAccept } = useForm();

  return (
    <div className="px-3.5 py-1.5 text-center">
      {paginator.previous && (
        <ChevronLeft
          className={`${PAGINATOR_ICON_STYLES} float-left`}
          onClick={() => {
            handleFormAccept(paginator?.previous?.action);
          }}
        />
      )}

      {paginator.next && (
        <ChevronRight
          className={`${PAGINATOR_ICON_STYLES} float-right`}
          onClick={() => {
            handleFormAccept(paginator?.next?.action);
          }}
        />
      )}

      <div className="text-primary text-base">{paginator.current?.name}</div>
    </div>
  );
};
